export default function IconChat({width}) {
    // Calculate height based on original aspect ratio (23.625 / 27.002)
    const aspectRatio = 23.625 / 27.002;
    const height = width * aspectRatio;

    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.002 23.625">
        <path id="chat" d="M13.5-10.969C13.5-4.91,7.457,0,0,0A16.146,16.146,0,0,1-5.49-.944,15.619,15.619,0,0,1-8.353.67a11.139,11.139,0,0,1-4.3,1.018.844.844,0,0,1-.78-.522.845.845,0,0,1,.179-.918l.016-.016c.016-.016.037-.037.069-.074.058-.063.148-.163.258-.3a10.16,10.16,0,0,0,.8-1.139A7.677,7.677,0,0,0-10.985-4.6a9.588,9.588,0,0,1-2.515-6.37c0-6.059,6.043-10.969,13.5-10.969S13.5-17.028,13.5-10.969Z" transform="translate(13.502 21.938)" fill="#fff"/>
    </svg>
}
